import { render, staticRenderFns } from "./BadgesModal.vue?vue&type=template&id=f212588a&scoped=true"
import script from "./BadgesModal.vue?vue&type=script&lang=js"
export * from "./BadgesModal.vue?vue&type=script&lang=js"
import style0 from "./BadgesModal.vue?vue&type=style&index=0&id=f212588a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f212588a",
  null
  
)

export default component.exports